import { render, staticRenderFns } from "./IconProjectMemberRole.vue?vue&type=template&id=2f080369&scoped=true"
import script from "./IconProjectMemberRole.vue?vue&type=script&lang=js"
export * from "./IconProjectMemberRole.vue?vue&type=script&lang=js"
import style0 from "./IconProjectMemberRole.vue?vue&type=style&index=0&id=2f080369&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2f080369",
  null
  
)

export default component.exports